var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoDoubleArrowPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33,
    height: 33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "#E3E5E9",
    fill: "#FFF",
    d: "M3.499 3.515h26v25.969h-26V3.515z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#B3B4B6",
    d: "M22.219 22.778c.274 0 .12-.1.33-.301.426.283.007-1.052-.407-1.227l-4.382-4.472 4.507-4.245c.424-.401.866-1.051.455-.733-.416-1.122-.162-1.122-1.09 0l-5.275 4.71c-.207-.266.003-.005-.067.268-.02.722-.153.534.047.726l5.127 4.973c.206.201.478.301.755.301z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#B3B4B6",
    d: "M17.88 22.778c-.521 0-.673-.1-.462-.301.429.283.004-1.052-.298-1.227l-4.488-4.472 4.502-4.245c.428-.401 1.166-1.051.454-.733-.415-1.122-.66-1.122-1.086 0l-5.276 4.71c-.026-.266-.322-.005-.328.268-.003.722.402.534.304.726l5.13 4.973c.205.201.481.301 1.548.301z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoDoubleArrowPrev);
export default __webpack_public_path__ + "static/media/ico-double-arrow-prev.e8b39dac95d89fcc57abc5e26ce63643.svg";
export { ForwardRef as ReactComponent };